import React from "react";
import { BiBadgeCheck } from "react-icons/bi";

const Frontend = () => {
  return (
    <div className="skill__content">
      <h3 className="skills__title">Frontent developer</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">HTML</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">CSS</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">Boostrap</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">Git</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />

            <div>
              <h3 className="skills__name">ReactJS</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Tailwind</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">NextJS</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Gsap</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Photoshop</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Figma</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">React Native</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          {/* JavaScript */}
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">JavaScript (ES6+)</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>

          {/* Redux (State Management) */}
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Redux / RTK</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          {/* Responsive Design & Cross‐Browser */}
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Responsive Design</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>

          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Cross‐Browser Testing</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          {/* TypeScript (Frontend) */}
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">TypeScript (React)</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          {/* API Integration (REST / GraphQL) */}
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">API Integration (REST/GraphQL)</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          {/* Unit Testing (Jest / React Testing Library) */}
          <div className="skills__data">
            <BiBadgeCheck className="skills__icon" />
            <div>
              <h3 className="skills__name">Unit Testing (Jest/RTL)</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Frontend;
